<div class="loc-container">
    <p class="title">{{title}}</p>
    <form [formGroup]="form" class="loc-form">
        <div class="loc-group">
            <label class="primaryColor">Nombre</label>
            <input name="name" formControlName="name" class="form-control text-may" placeholder="Nombre">
            <div class="invalid-text" *ngIf="form.get('name').invalid && form.get('name').touched">Ingrese un nombre valido</div>
        </div>
     
        <div class="loc-group">
            <label class="primaryColor">Descripcion</label>
            <input formControlName="description" type="text" class="form-control text-may" placeholder="Descripcion">
            <div class="invalid-text" *ngIf="form.get('description').invalid && form.get('description').touched">Ingrese una descripcion valida</div>
        </div>
        <div class="loc-group">
            <label class="primaryColor">Parametrizacion</label>
            <select formControlName="customerId" class="form-control">
                <option class="ligthColor" value=null>Seleccione una parametrizacion</option>
                <option *ngFor="let c of parametrizationList" value="{{c.id}}">{{c.description}} || {{c.customer}}</option>
            </select>
        </div>
        <div *ngIf="formId != 0" class="loc-group-checkbox">
            <label class="primaryColor">Activo</label>
            <div class="loc-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                <div class="loc-checkbox">
                    <input id="check" formControlName="active" type="checkbox">
                    <label class="loc-label" for="check">
                        <mat-icon>done</mat-icon>
                    </label>
                </div>
            </div>
        </div>
        <div class="loc-group">
            <label class="primaryColor">Guardar</label>
            <div class="loc-container-button">
                <button type="reset" class="loc-button" mat-raised-button matTooltip="Guardar" mat-raised-button [disabled]="!form.valid" matTooltipPosition="right" matTooltipClass="tooltip" (click)="save()">
                    <mat-icon>save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>